import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { State } from "./state";

export default {
} as GetterTree<State, RootState>;
